import { useCallback, useState } from "react";
import { useDisclosure } from "@chakra-ui/react";
import { useStores } from "../../../stores/setup/use-store";
import { ILocation, CoordinatesType } from "../types/";

export const useLocationActions = (
  handleOpenDrawer: (location?: ILocation) => void,
  handleOpenModal?: (stationId: number, regionId: number) => void
) => {
  const {
    dataStores: { locationStore },
  } = useStores();

  const [locationToDelete, setLocationToDelete] =
    useState<ILocation | null>(null);
  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const handleCreateLocation = useCallback(
    (type: CoordinatesType) => {
      handleOpenDrawer();
    },
    [handleOpenDrawer]
  );

  const handleEdit = useCallback(
    (location: ILocation) => {
      if (location.coordinatesType === CoordinatesType.AREA) {
        if (location && location.id) {
          handleOpenDrawer(location);
        } else {
          console.error("Location or location ID is missing:", location);
        }
      } else if (location.coordinatesType === CoordinatesType.POINT) {
        if (handleOpenModal && location.id && location.regionId) {
          handleOpenModal(location.id, location.regionId);
        }
      }
    },
    [handleOpenDrawer, handleOpenModal]
  );

  const handleDelete = useCallback(
    (location: ILocation) => {
      setLocationToDelete(location);
      onDeleteOpen();
    },
    [onDeleteOpen]
  );

  const handleConfirmDelete = useCallback(async () => {
    if (locationToDelete) {
      await locationStore.deleteLocationAPI(locationToDelete.id);
      setLocationToDelete(null);
      onDeleteClose();
    }
  }, [locationToDelete, locationStore, onDeleteClose]);

  const canDeleteRow = useCallback((location: ILocation) => {
    return location.coordinatesType === CoordinatesType.AREA;
  }, []);

  return {
    handleCreateLocation,
    handleEdit,
    handleDelete,
    isDeleteOpen,
    onDeleteClose,
    locationToDelete,
    handleConfirmDelete,
    canDeleteRow,
  };
};
